/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ToFromData2 } from './ToFromData2';
import {
    ToFromData2FromJSON,
    ToFromData2FromJSONTyped,
    ToFromData2ToJSON,
} from './ToFromData2';

/**
 * 
 * @export
 * @interface Schedule2
 */
export interface Schedule2 {
    /**
     * 
     * @type {Array<ToFromData2>}
     * @memberof Schedule2
     */
    monday: Array<ToFromData2> | null;
    /**
     * 
     * @type {Array<ToFromData2>}
     * @memberof Schedule2
     */
    tuesday: Array<ToFromData2> | null;
    /**
     * 
     * @type {Array<ToFromData2>}
     * @memberof Schedule2
     */
    wednesday: Array<ToFromData2> | null;
    /**
     * 
     * @type {Array<ToFromData2>}
     * @memberof Schedule2
     */
    thursday: Array<ToFromData2> | null;
    /**
     * 
     * @type {Array<ToFromData2>}
     * @memberof Schedule2
     */
    friday: Array<ToFromData2> | null;
    /**
     * 
     * @type {Array<ToFromData2>}
     * @memberof Schedule2
     */
    saturday: Array<ToFromData2> | null;
    /**
     * 
     * @type {Array<ToFromData2>}
     * @memberof Schedule2
     */
    sunday: Array<ToFromData2> | null;
}

/**
 * Check if a given object implements the Schedule2 interface.
 */
export function instanceOfSchedule2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "monday" in value;
    isInstance = isInstance && "tuesday" in value;
    isInstance = isInstance && "wednesday" in value;
    isInstance = isInstance && "thursday" in value;
    isInstance = isInstance && "friday" in value;
    isInstance = isInstance && "saturday" in value;
    isInstance = isInstance && "sunday" in value;

    return isInstance;
}

export function Schedule2FromJSON(json: any): Schedule2 {
    return Schedule2FromJSONTyped(json, false);
}

export function Schedule2FromJSONTyped(json: any, ignoreDiscriminator: boolean): Schedule2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monday': (json['monday'] === null ? null : (json['monday'] as Array<any>).map(ToFromData2FromJSON)),
        'tuesday': (json['tuesday'] === null ? null : (json['tuesday'] as Array<any>).map(ToFromData2FromJSON)),
        'wednesday': (json['wednesday'] === null ? null : (json['wednesday'] as Array<any>).map(ToFromData2FromJSON)),
        'thursday': (json['thursday'] === null ? null : (json['thursday'] as Array<any>).map(ToFromData2FromJSON)),
        'friday': (json['friday'] === null ? null : (json['friday'] as Array<any>).map(ToFromData2FromJSON)),
        'saturday': (json['saturday'] === null ? null : (json['saturday'] as Array<any>).map(ToFromData2FromJSON)),
        'sunday': (json['sunday'] === null ? null : (json['sunday'] as Array<any>).map(ToFromData2FromJSON)),
    };
}

export function Schedule2ToJSON(value?: Schedule2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monday': (value.monday === null ? null : (value.monday as Array<any>).map(ToFromData2ToJSON)),
        'tuesday': (value.tuesday === null ? null : (value.tuesday as Array<any>).map(ToFromData2ToJSON)),
        'wednesday': (value.wednesday === null ? null : (value.wednesday as Array<any>).map(ToFromData2ToJSON)),
        'thursday': (value.thursday === null ? null : (value.thursday as Array<any>).map(ToFromData2ToJSON)),
        'friday': (value.friday === null ? null : (value.friday as Array<any>).map(ToFromData2ToJSON)),
        'saturday': (value.saturday === null ? null : (value.saturday as Array<any>).map(ToFromData2ToJSON)),
        'sunday': (value.sunday === null ? null : (value.sunday as Array<any>).map(ToFromData2ToJSON)),
    };
}

